import React from 'react';
import './_AnchorLink.scss';
import { TfiAngleUp } from 'react-icons/tfi';

export function AnchorLink() {
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className='ui circular icon button icon-btn'
      onClick={goToTop}
      type='button'
      aria-label='goToTop'
    >
      <TfiAngleUp size='2rem' />
    </button>
  );
}
